export type SidebarSectionId =
  | 'inicio'
  | 'operacion'
  | 'libros'
  | 'reportes'
  | 'tributario'
  | 'asistente'
  | 'configuracion';

const LS_KEY = 'quipus:sidebar:open-sections';

export function getSectionForRoute(route: string): SidebarSectionId {
  if (
    route === '/' ||
    route.startsWith('/dashboard') ||
    route.startsWith('/mi-negocio')          // old path compat
  ) return 'inicio';

  if (
    route.startsWith('/upload') ||
    route.startsWith('/bank-inbox') ||
    route.startsWith('/inbox') ||
    route.startsWith('/cargas-fallidas') ||
    route.startsWith('/inbox-fallidos') ||   // old path compat
    route.startsWith('/loans') ||
    route.startsWith('/agentes')
  ) return 'operacion';

  if (
    route.startsWith('/journals') ||
    route.startsWith('/libro-diario') ||
    route.startsWith('/libro-mayor') ||
    route.startsWith('/sumas-saldos')
  ) return 'libros';

  if (
    route.startsWith('/cierre') ||
    route.startsWith('/balance') ||
    route.startsWith('/pyg') ||
    route.startsWith('/flujo') ||
    route.startsWith('/cxp') ||
    route.startsWith('/cxc')
  ) return 'reportes';

  if (
    route.startsWith('/tributaria') ||
    route.startsWith('/compras') ||
    route.startsWith('/ventas') ||
    route.startsWith('/impuestos') ||
    route.startsWith('/declaraciones') ||
    route.startsWith('/pdt')            ||   // old path compat
    route.startsWith('/detracciones') ||
    route.startsWith('/maestro-fiscal') ||
    route.startsWith('/categorizer')    ||   // old path compat
    route.startsWith('/libros-pe') ||
    route.startsWith('/libros-ple')          // old path compat
  ) return 'tributario';

  if (
    route.startsWith('/biblioteca') ||
    route.startsWith('/ai-assistant')
  ) return 'asistente';

  if (
    route.startsWith('/perfil-empresa') ||
    route.startsWith('/bank-accounts') ||
    route.startsWith('/audit') ||
    route.startsWith('/settings')
  ) return 'configuracion';

  // Default: inicio (covers /contador, /welcome, etc.)
  return 'inicio';
}

export function getInitialOpenSections(currentRoute: string): Set<SidebarSectionId> {
  const stored = localStorage.getItem(LS_KEY);
  if (stored) {
    try { return new Set(JSON.parse(stored) as SidebarSectionId[]); } catch {}
  }
  return new Set([getSectionForRoute(currentRoute)]);
}

export function persistOpenSections(open: Set<SidebarSectionId>): void {
  localStorage.setItem(LS_KEY, JSON.stringify([...open]));
}
